<div class="table-container">
  <div [@simpleFadeAnimation]="ready ? 'fadeIn': 'fadeOut'">
    <mat-button-toggle-group
      #group="matButtonToggleGroup"
      name="fontStyle"
      aria-label="Font Style"
      [value]="selectedVal"
      (change)="onValChange(group.value)"
    >
      <mat-button-toggle value="1 years">1Y</mat-button-toggle>
      <mat-button-toggle value="3 months">3M</mat-button-toggle>
      <mat-button-toggle value="1 months">1M</mat-button-toggle>
      <mat-button-toggle value="1 weeks">1W</mat-button-toggle>
      <!-- <mat-button-toggle value="1 days">1D</mat-button-toggle> -->
    </mat-button-toggle-group>
    <div
      #chart
      class="chart"
      id="chart"
    ></div>
  </div>
</div>
